import { MaterialModule } from './../../app_mobile/material.module';
import { PickerModule } from "@ctrl/ngx-emoji-mart";
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import {NgModule} from '@angular/core';
import { EmojiPicker } from './emoji-picker'; 
import { EmojiItem } from './emoji-picker-item';
@NgModule({
imports: [MaterialModule, PickerModule, EmojiModule],
declarations:[EmojiPicker, EmojiItem],
exports:[EmojiPicker, EmojiItem]
})
export class EmojiShareModule
{
}